import React, { Component } from 'react';
import { string } from 'prop-types';
import compose from 'lodash/flowRight';
import classnames from 'classnames';
import { connectSearchBox } from 'react-instantsearch-dom';
import { Breadcrumb } from 'components';
import withGTM from 'components/WithGTM/WithGTM';
import { brandShape, categoryShape } from 'shapes';
import { withBrand, withCategory, withListingType } from 'connectors';
import { Sentry } from 'utils';
import { getHeaderTitle, isCategoryValid } from './utils';
import './ListingHeader.scss';

class ListingHeader extends Component {
    static propTypes = {
        category: categoryShape,
        currentRefinement: string,
        listingType: string,
        brand: brandShape,
    };

    static defaultProps = {
        category: null,
        currentRefinement: '',
        listingType: '',
        brand: null,
    };

    getTitle = () => {
        const {
            brand,
            category,
            currentRefinement: searchQuery,
            listingType,
        } = this.props;
        return getHeaderTitle({ brand, category, listingType, searchQuery });
    };

    componentDidCatch(err) {
        Sentry.captureException(err);
    }

    render() {
        const { category, listingType, brand } = this.props;
        const shouldShowBreadcrumb =
            isCategoryValid({ category, listingType }) &&
            category.context.breadcrumb;
        const rootClassNames = classnames('listing-header', {
            'listing-header--category': isCategoryValid({
                category,
                listingType,
            }),
            'listing-header--brand': listingType === 'brand',
            'listing-header--search': listingType === 'search',
        });

        const QATitle =
            listingType === 'search' ? 'searchTitleElm' : 'categoryTitleElm';

        return (
            <div className={rootClassNames}>
                {shouldShowBreadcrumb && (
                    <Breadcrumb crumbs={category.context.breadcrumb} />
                )}
                <h1 className="listing-header__title" data-qa={QATitle}>
                    {this.getTitle()}
                </h1>
                {brand?.description && (
                    <div
                        className="listing-header__description"
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{ __html: brand.description }}
                    />
                )}
            </div>
        );
    }
}

export default compose(
    withGTM,
    withListingType,
    withBrand,
    withCategory,
    connectSearchBox,
)(ListingHeader);
